import { IReduxState } from 'app/types/state';

export const getIsEmailResendFetching = (state: IReduxState) => state.emailResendReducer.isFetching;
export const getEmailResendStatus = (state: IReduxState) => state.emailResendReducer.status;
export const getEmailResendCountdownStart = (state: IReduxState) => state.emailResendReducer.countdownStart;
export const getSentToEmailAdress = (state: IReduxState) => state.emailResendReducer.sentToEmail;
